document.addEventListener('DOMContentLoaded', function () {
  const bgItems = document.querySelectorAll('.js-bgItem');
  const arrow = document.querySelector('.js-firstViewArrow');
  let current = 0;

  if (bgItems.length === 0) {
    return;
  }

  bgItems.forEach((item, index) => {
    item.style.opacity = 0;

    if (index === 0) {
      item.style.opacity = 1;
      item.classList.add('is-animated');
    }
  });

  function toggleBg() {
    const currentItem = bgItems[current];
    const nextItem = bgItems[(current + 1) % bgItems.length];

    setTimeout(() => {
      arrow.classList.add('is-animated');

      setTimeout(() => {
        currentItem.style.opacity = 0;
        currentItem.classList.remove('is-animated');
        nextItem.style.opacity = 1;
        nextItem.classList.add('is-animated');

        setTimeout(() => {
          arrow.classList.remove('is-animated');
          current = (current + 1) % bgItems.length;
          toggleBg();
        }, 1500);
      }, 1500);
    }, 4000);
  }

  toggleBg();
});
